/** @jsxImportSource @emotion/react */
import { NewsListItem } from "../model/NewsListSuccessResponse";
import { routes } from "../../../appRoutingHelpers";
import { TableRow } from "../../../components/table-components/TableRow";
import { TableCellLink } from "../../../components/table-components/TableCellLink";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";
import { firstTableCellStyle } from "../../../style-util";
import { useSelector } from "react-redux";
import * as authSelectors from "../../auth/authSelectors";
import { Avatar } from "../../../components/Avatar";
import { TableEllipsisDropdown } from "../../../components/TableEllipsisDropdown";
import { useDeleteNews } from "../../../service/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { DropdownItemButton } from "../../common/DropdownItemButton";
import { getErrorMessage } from "../../../error-handler";
import { toastr } from "react-redux-toastr";
import { DropdownItemLink } from "../../common/DropdownItemLink";

type Props = {
  news: NewsListItem;
};

export const NewsListRow = ({ news }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const href = routes.newsEdit(organizationKeyName, news.id);

  const {
    mutateAsync: deleteNews,
    isLoading: isDeletingNews,
  } = useDeleteNews();

  return (
    <TableRow>
      <TableCellLink href={href} css={firstTableCellStyle}>
        <Avatar imageUrl={news.imageUrl}>
          {news.title.charAt(0).toUpperCase()}
        </Avatar>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {news.title}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {news.externalUrl}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {news.countryCode}
        </StyledText>
      </TableCellLink>
      <TableEllipsisDropdown
        menu={{
          items: [
            {
              key: "1",
              label: (
                <DropdownItemLink
                  icon={<FontAwesomeIcon icon={solid("pen")} />}
                  to={href}
                >
                  Edit
                </DropdownItemLink>
              ),
            },
            {
              key: "2",
              label: (
                <DropdownItemButton
                  icon={<FontAwesomeIcon icon={solid("trash")} />}
                  disabled={isDeletingNews}
                  onClick={async () => {
                    try {
                      await deleteNews({
                        organizationKeyName,
                        data: { id: news.id },
                      });
                      toastr.success("Success", "News deleted successfully");
                    } catch (error: unknown) {
                      const errorMessage = getErrorMessage(error);
                      toastr.error("Error", errorMessage);
                    }
                  }}
                >
                  Delete news
                </DropdownItemButton>
              ),
            },
          ],
        }}
      />
    </TableRow>
  );
};
